/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyPlExciseDutyGoodsType,
    ReadOnlyPlExciseDutyGoodsTypeFromJSON,
    ReadOnlyPlExciseDutyGoodsTypeFromJSONTyped,
    ReadOnlyPlExciseDutyGoodsTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20039
 */
export interface InlineResponse20039 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20039
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20039
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20039
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyPlExciseDutyGoodsType>}
     * @memberof InlineResponse20039
     */
    results: Array<ReadOnlyPlExciseDutyGoodsType>;
}

export function InlineResponse20039FromJSON(json: any): InlineResponse20039 {
    return InlineResponse20039FromJSONTyped(json, false);
}

export function InlineResponse20039FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20039 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyPlExciseDutyGoodsTypeFromJSON)),
    };
}

export function InlineResponse20039ToJSON(value?: InlineResponse20039 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyPlExciseDutyGoodsTypeToJSON)),
    };
}


